module.exports = __webpack_public_path__ + "static/media/xz10_grey.77371c8d.png";